module.exports = {"441427103":"三圳镇","441427106":"文福镇","441427107":"广福镇","441427112":"新铺镇","441427113":"蓝坊镇","441427114":"南礤镇","441427115":"蕉城镇","441427116":"长潭镇","441427450":"华侨农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/441427.json
// module id = 2156
// module chunks = 0